let authActionModule;
if (process.env.NODE_ENV === "production") {
  authActionModule = require("./auth.action.obf.js");
} else {
  authActionModule = require("./auth.action.js");
}
module.exports = authActionModule;
